import { render, staticRenderFns } from "./import-async.vue?vue&type=template&id=9f25ce5a&scoped=true"
import script from "./import-async.vue?vue&type=script&lang=js"
export * from "./import-async.vue?vue&type=script&lang=js"
import style0 from "./import-async.vue?vue&type=style&index=0&id=9f25ce5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f25ce5a",
  null
  
)

export default component.exports